<template>
<nav v-if="menu" class="nav"  role="navigation">
  <ul class="nav__list top-menu">
    <li v-for="(item,key) in menu.items" :key="key" class="nav__item" :class="{selected:item.href === currentPage}">
      <span :title="item.title" @click="clickMenuItem($event,item.href)">
        {{ item.title }}
      </span>
    </li>
  </ul>
</nav>
</template>
<script setup lang="ts">
import { storeToRefs } from 'pinia';
import {usePagesStore} from "@stores/pages";
import type { Props } from './model';
import type { Emits } from './model/types';


defineOptions({
  name:'AppNavMenu'
})


const pagesStore = usePagesStore();

const {currentPage} = storeToRefs(pagesStore)
const props = defineProps<Props>();
const emit = defineEmits<Emits>();
const clickMenuItem = (event: MouseEvent, href: string): void => {
  emit('click', event, href)
}
</script>
<style lang="scss">
.nav{
  flex-shrink: 1;
  &__list{
    margin: 0;
    padding: 0;
    display: flex;
    column-gap: 0.6rem;
    align-items: center;
    align-content: center;
    list-style: none;
    flex-direction: column;
    @media screen and (max-width: 768px){
      flex-direction: column;
      gap: 0.6rem;
      padding: 0 var(--space-30);
      text-align: center;
    }
    &.column{
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: var(--space-16);
      align-items: flex-start;
      .nav__item{
        padding: 0;
      }
    }
    &.top-menu{
      align-items: center;
      align-content: center;
      gap: var(--space-32);
      @media screen and (max-width: 768px){
        gap: var(--space-16);
      }
      .nav__item{
        font-size: var(--font-size-20);
        @media screen and (max-width: 768px){
          font-size: var(--font-size-14);
        }
        &.selected{
          color: var(--color-secondary);
        }
        &:not(:first-child){
          font-family: var(--ff-heading);
          font-size: var(--font-size-28);
          text-transform: uppercase;
          @media screen and (max-width: 768px){
            font-size: var(--font-size-20);
          }
        }
      }
      @media screen and (orientation: landscape) and (max-width: 768px ){
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: var(--space-16);
        align-items: flex-start;
        .nav__item{
          padding: 0;
          &:not(:first-child){
            font-family: var(--ff-heading);
            font-size: var(--font-size-20);
          }
        }
      }
    }
  }
  &__item{
    font-size: var(--font-size-20);
    padding: 0 1.2rem;
    position: relative;
    cursor: pointer;
    span:hover{
      color: var(--color-secondary);
    }
  }
}
</style>